$(document).ready(function(){
  $("#product-add-to-cart").click(function(e){
    e.preventDefault();
   
    var got = 'true';
    var size = $('input[name="properties[Size]"]:checked').val();
    if($('label.custom-size').hasClass('custom-selected') || size == 'Custom Size (Inch)'){
    
      if ($("#bust").val() == "" ) {
        $("#bust").css('border', "1.5px solid red");
        var got = 'false'
      }
      else{
        $("#bust").css('border', "1.5px solid #f1f1f1");
      }
        
      if($("#waist").val() == ""){
        $("#waist").css('border', "1.5px solid red");
        var got = 'false'
      } 
      else{
        $("#waist").css('border', "1.5px solid #f1f1f1");
      }
        
      if($("#hips").val() == "") {
        $("#hips").css('border', "1.5px solid red");
        var got = 'false'
      }
      else{
        $("#hips").css('border', "1.5px solid #f1f1f1");
      }
        
      if($("#hollow").val() == "") {
        $("#hollow").css('border', "1.5px solid red");
        var got = 'false'
      }
      else{
        $("#hollow").css('border', "1.5px solid #f1f1f1");
      }
      
      if($("#hollow2").val() == "") {
        $("#hollow2").css('border', "1.5px solid red");
        var got = 'false'
      }
      else{
        $("#hollow2").css('border', "1.5px solid #f1f1f1");
      }
      
      if($("#length").val() == "") {
        $("#length").css('border', "1.5px solid red");
        var got = 'false'
      }
      else{
        $("#length").css('border', "1.5px solid #f1f1f1");
      }
        
      if($("#confirma").is(':checked')) {
        $(".confirm").css('border', "1.5px solid #f1f1f1");
      }  
      else{
        $(".confirm").css('border', "1.5px solid red");
      }
    }

    var selectedColor = jQuery('#product-selectors-option-0').val();
    var checkWord = 'color';
    var CustomColor = '';
    if(selectedColor.indexOf(checkWord) != -1){
      if(jQuery('#custom_color_h').val()==1){
        if(jQuery('[name="properties[custom_color]"]').length==1){
          CustomColor = jQuery('[name="properties[custom_color]"]').val();
        }else{
          got='false'; 
        }
      }else{
        got='false';
      }
     }
    if(got=='false'){
      jQuery('.cart-button-error').remove();
      jQuery('.product-add-to-cart').parent('div').after('<p class="cart-button-error" style="color:#FF0000;"><b>Some thing went to wrong</b></p>');
    }
   if(got == 'true'){
      $('#AddToCartText-Template_Design_one').hide();
      $('.loader_Add_Cat').removeClass('hide');

     var mainVarintid = $('#product-selectors').val();
     var size = $('input[name="properties[Size]"]:checked').val();
     var style = $('input[name="properties[General Closure Style]"]:checked').val();
     var Bust = $('#bust').val();
     var Waist = $('#waist').val();
     var Hips = $('#hips').val();
     var HollowToFloor = $('#hollow').val();
     var BareFootHeight = $('#hollow2').val();
     var ExtraLength = $('#length').val();
     var customProductId = $('#customProductId').val();
     var custom_size_h = $('#custom_size_h').val();
      
     if(size == 'Custom Size (Inch)'){
       var formData = {
        'items': [{
            'id': mainVarintid,
            'quantity': 1,
            "properties" : {
              "Size": size,
              "General Closure Style": style,
              "Bust": Bust,
              "Waist": Waist,
              "Hips": Hips,
              "Hollow to Floor": HollowToFloor,
              "Bare foot height": BareFootHeight,
              "Extra Length": ExtraLength,
              "General": Bust,
                "Custom Color" :CustomColor
            }
          },
           {
            'id': customProductId,
            'quantity': 1
          }]
        };
     }
    else if (custom_size_h == 1){
      var formData = {
        'items': [{
            'id': mainVarintid,
            'quantity': 1,
            "properties" : {
              "Size": size,
              "General Closure Style": style,
              "Bust": Bust,
              "Waist": Waist,
              "Hips": Hips,
              "Hollow to Floor": HollowToFloor,
              "Bare foot height": BareFootHeight,
              "Extra Length": ExtraLength,
              "Custom Color" :CustomColor
            }
          }]
        };
    }
    else{
       var formData = {
        'items': [{
            'id': mainVarintid,
            'quantity': 1,
            "properties" : {
              "Size": size,
              "General Closure Style": style,
              "Custom Color" :CustomColor
            }
          }]
        };
     }
     console.log(formData);
     
      $.ajax({
        // type: 'POST',
        // url: '/cart/add.js',
        // data:$(".shopify-product-form").serialize(),
        // dataType: 'json',
        type: 'POST',
        url: '/cart/add.js',
        data:formData,
        dataType: 'json',
        success: function(response){
          
          jQuery.getJSON('/cart.js', function(cart) {
            console.log(cart);
            //alert('There are now ' + cart.item_count + ' items in the cart.');
            
            var price = cart.total_price/100;
            let items = cart.items;
            var prodct_has_cart = [];
            for(var i=0; i < items.length; i++){
              var item_id = items[i].id;
              if(item_id ==  42220599574598){
                prodct_has_cart.push(1);
              }
            }
            if (price > 9999999){
              if(prodct_has_cart[0] != 1){
                $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: '&id=42220599574598', 
                  dataType: 'json',
                  success:function(response) {
                    window.location.href = '/cart';
                  }
                });
              }
              else{
                window.location.href = '/cart';
              }  
            }
            else{
              jQuery.post('/cart/update.js', 'updates[42220599574598]=0');
                window.location.href = '/cart';
            }
         });
        },
        error: function(resp) {
          var getres = JSON.stringify(resp);
          alert(resp.responseJSON.description);
        }
      });
   }
  });
});
